module.exports = __webpack_public_path__ + "img/source.0ffc62c5.gif";